"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultMp4PreloaderConfig = void 0;
var DefaultMp4PreloaderConfig = exports.DefaultMp4PreloaderConfig = {
  enabled: true,
  minBufferPercentageBeforePreload: 0.9,
  numberOfMp4PlayablesToPreload: 2
};